module.exports = __webpack_public_path__ + "img/module-telehealth.dca0aa91.svg";